import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { newSmart, useRouter, useUIComponents, useTranslate, } from "@bluelibs/x-ui";
import { ReadyForPaymentListAntTableSmart } from "./ReadyForPaymentListTableSmart";
import * as Ant from "antd";
import { useAppGuardian } from "@bundles/UIAppBundle/services/AppGuardian";
export function ReadyForPaymentList() {
    var _a, _b;
    const { state } = useAppGuardian();
    const UIComponents = useUIComponents();
    const router = useRouter();
    const t = useTranslate();
    const [api, Provider] = newSmart(ReadyForPaymentListAntTableSmart, {
        initialFilters: {
            "approval.status": true,
            type: "expense",
            isCompleted: false,
        },
    });
    api.setRoles(((_b = (_a = state === null || state === void 0 ? void 0 : state.user) === null || _a === void 0 ? void 0 : _a.roles) !== null && _b !== void 0 ? _b : []));
    return (_jsx(UIComponents.AdminLayout, { children: _jsxs("div", Object.assign({ className: "bg-white page-ready-for-payment-transactions-list" }, { children: [_jsx(Ant.PageHeader, { title: t("management.transactions.menu.ready_for_payment") }, void 0), api.state.isError && (_jsx(Ant.Alert, { type: "error", message: t("generics.error_message") }, void 0)), _jsx(Ant.Layout.Content, { children: _jsx(Provider, { children: _jsx("div", Object.assign({ className: "page-transactions-list" }, { children: _jsx(Ant.Table, Object.assign({}, api.getTableProps()), void 0) }), void 0) }, void 0) }, void 0)] }), void 0) }, void 0));
}
